import {Component, forwardRef} from '@angular/core';
import {DictionariesService} from "../../../service";
import {IIdCodeDescription} from "../../../models";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ViewDictionaryBase} from "../view-dictionary-base";

@Component({
  selector: 'app-dict-qref-kodTypeDoc',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefKodTypeDocViewComponent),
    multi: true
  }],
  template: `
    <div class="mb-3 pl-0 pr-0">
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select code="code"
                         name="description"
                         [items]="dictionary | async"
                         [returnOnlyId]="true"
                         [formControl]="formControl"
                         [fieldsFromSearch]="'description'"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
          {{ item.description }}
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
          <div style="white-space: normal">
            {{ item.description }}
          </div>
        </ng-template>
      </app-custom-select>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
    </div>
  `
})
export class QrefKodTypeDocViewComponent extends ViewDictionaryBase<IIdCodeDescription> {
  getDictionary = this.dictSrv.getQrefKodTypeDocList();
  constructor(private dictSrv: DictionariesService) {
    super();
  }
}
